import type { TRoomInfoList } from "./types";
import { getPaginatedFilteredPathParam } from "@/api/shared/crud";
import { createService } from "@/api/shared/service";
import type { DefaultPaginatedFilters } from "@/api/shared/filters";

export * from "./types";

const SLUG = "message/room-info";

type RoomInfoParam = { patientId: string };

export interface RoomInfoFilters extends DefaultPaginatedFilters, RoomInfoParam {}

export default createService(SLUG, {
  getPatientRoomInfo: getPaginatedFilteredPathParam<TRoomInfoList, RoomInfoParam, RoomInfoFilters>(
    `${SLUG}/{patientId}`
  ),
});
